export default "__VITE_ASSET__C$UsM1hJ__"